import _ from "lodash";
import React, { useMemo, useState } from "react";
import { useBalanceStore } from "../../_store/balanceStore";
import { useDebtStore } from "../../_store/debtplanStore";
import { useEducationStore } from "../../_store/educationStore";
import { useFuturePlanStore } from "../../_store/futurePlanStore";
import { useInsuranceStore } from "../../_store/insuranceStore";
import { useInvestStore } from "../../_store/investStore";
import { useRetireStore } from "../../_store/retireStore";
import { useTaxStore } from "../../_store/taxplanStore";
import { useUserStore } from "../../_store/userStore";
import {
  DeductionSumPDF,
  ExceptionSumPDF,
  Income403PerPage,
  Income404PerPage,
  Income404StockPerPage,
  Income405PerPage,
  Income406PerPage,
  Income407PerPage,
  Income408PerPage,
  Income408PropertyPerPage,
  Income408ReciveDetailFunction,
  TaxHeirachyPDF,
} from "../../functions/pdfGenerateFunction/pdfFunction";
import { pdfFutureFourFunction } from "../../functions/pdfGenerateFunction/pdfFunctionSecond";
import {
  ChildrenEducationExpensePDF,
  FutureCarExpensePDF,
  FutureChildrenExpensePDF,
  FutureCollectionExpensePDF,
  FutureETCExpensePDF,
  FutureHomeExpensePDF,
  FutureTravelExpensePDF,
  LegacyIncomePDF,
  OtherIncomePDF,
  PropertyIncomePDF,
  SellBusinessIncomePDF,
} from "../../functions/pdfGenerateFunction/pdfFutureFunction";
import { PdfPageInvestTwo_Items } from "../../functions/pdfGenerateFunction/PdfPageInvestTwoFunc";
import TaxHeirachy, {
  ExceptionLists,
} from "../../functions/taxFucntion/taxHeirachy";
import {
  calDebtCreditCard,
  calTotalCreditorFloatInterest,
  cn,
  generateAmortizationSchedule,
} from "../../utils/useFunctions";
import { key_property_invest_category } from "../balance/functions";
import { options_debt } from "../balance/styles/Card";
import { formatPeriodTime } from "../debt/component/VIDebtTable";
import AllInsuranceNumber from "./Insurance/allInsuranceNumber";
import ExpenseInsuranceDetailPDF from "./Insurance/expenseInsuranceDetail.pdf";
import ExpenseInsuranceDetailCarPDF from "./Insurance/expenseInsuranceDetailCar.pdf";
import ExpenseInsuranceDetailFifthPDF from "./Insurance/expenseInsuranceDetailFifth.pdf";
import ExpenseInsuranceDetailFirePDF from "./Insurance/expenseInsuranceDetailFire.pdf";
import ExpenseInsuranceDetailFourPDF from "./Insurance/expenseInsuranceDetailFour.pdf ";
import ExpenseInsuranceDetailHomePDF from "./Insurance/expenseInsuranceDetailHome.pdf";
import ExpenseInsuranceDetailThreePDF from "./Insurance/expenseInsuranceDetailThree.pdf";
import ExpenseInsuranceDetailTwoPDF from "./Insurance/expenseInsuranceDetailTwo.pdf";
import { InsureRanceLists } from "./Insurance/insureRanceLists";
import PdfDownload from "./pdf.download";
import ExpenseFuturePDF from "./premiumFuture/expenseFuture.pdf";
import IncomeFuturePDF from "./premiumFuture/incomeFuture.pdf";
import ResultChartFuturePdf from "./premiumFuture/resultChartFuture.pdf";
import Income402Pdf from "./premiumTax/income402.pdf";
import Income403Pdf from "./premiumTax/income403.pdf";
import Income404Pdf from "./premiumTax/income404.pdf";
import Income408StockPdf from "./premiumTax/income404Stock.pdf";
import Income405Pdf from "./premiumTax/income405.pdf";
import Income406Pdf from "./premiumTax/income406.pdf";
import Income407Pdf from "./premiumTax/income407.pdf";
import Income408Pdf from "./premiumTax/income408.pdf";
import Income408property from "./premiumTax/income408property.pdf";
import Income408Recive from "./premiumTax/income408Recive.pdf";
import Income408ReciveDetail from "./premiumTax/income408ReciveDetail.pdf";
import IncomeProfilePdf from "./premiumTax/incomeProfile.pdf";
import IncomeResultPDF from "./premiumTax/incomeResult.pdf";
import IncomeRMFPdf from "./premiumTax/incomeRMF.pdf";
import IncomeSSFPdf from "./premiumTax/incomeSSF.pdf";
import IncomeTaxNotIncludePdf from "./premiumTax/incomeTaxNotInclude.pdf";
import QuitJobIncomePdf from "./premiumTax/quitjob.result.pdf";
import SalaryIncomePdf from "./premiumTax/salary.Income.pdf";
import TaxDeductionPDF from "./premiumTax/taxDeduction.pdf";
import TaxExceptionPDF from "./premiumTax/taxException.pdf";
import { STYLE_PDF_CONTENT } from "./styles/pdf.style";
import PdfPageAppendix from "./view/pdf.v.pageAppendix";
import { PdfPageAppendixEducationTwo } from "./view/pdf.v.pageAppendixEducationOne";
import PdfPageAssumeOne from "./view/pdf.v.pageAssumeOne";
import PdfPageBalananceFive from "./view/pdf.v.pageBalanceFive";
import PdfPageBalananceFour from "./view/pdf.v.pageBalanceFour";
import PdfPageBalananceFourExtra from "./view/pdf.v.pageBalanceFourExtra";
import PdfPageBalananceOne from "./view/pdf.v.pageBalanceOne";
import PdfPageBalananceEight from "./view/pdf.v.pageBalanceSeven";
import PdfPageBalananceSix from "./view/pdf.v.pageBalanceSix";
import PdfPageBalananceThree from "./view/pdf.v.pageBalanceThree";
import PdfPageBalananceTwo from "./view/pdf.v.pageBalanceTwo";
import PdfPageDebtFour from "./view/pdf.v.pageDebtFour";
import PdfPageDebtOne from "./view/pdf.v.pageDebtOne";
import PdfPageDebtOneSum from "./view/pdf.v.pageDebtOneSum";
import PdfPageDebtThree from "./view/pdf.v.pageDebtThree";
import PdfPageDebtTwo from "./view/pdf.v.pageDebtTwo";
import {
  PdfPageEducationThree,
  PdfPageEducationTwo,
} from "./view/pdf.v.pageEducation";
import PdfPageFamilyOne from "./view/pdf.v.pageFamilyOne";
import PdfPageFamilyThree from "./view/pdf.v.pageFamilyThree";
import PdfPageFamilyTwo from "./view/pdf.v.pageFamilyTwo";
import PdfPageFinacialOne from "./view/pdf.v.pageFinacialOne";
import PdfPageFinacialLanding from "./view/pdf.v.pageFinalcialLanding";
import PdfPageFinacialTwo from "./view/pdf.v.pageFinalcialTwo";
import PdfPageFutureFour from "./view/pdf.v.pageFutureFour";
import PdfPageInvestFive, {
  getRandomHexColor,
} from "./view/pdf.v.pageInvestFive";
import PdfPageInvestFour from "./view/pdf.v.pageInvestFour";
import PdfPageInvestOne from "./view/pdf.v.pageInvestOne";
import PdfPageInvestThree from "./view/pdf.v.pageInvestThree";
import PdfPageInvestTwo from "./view/pdf.v.pageInvestTwo";
import PageLanding from "./view/pdf.v.pageLanding";
import PdfPageOVDebtOne from "./view/pdf.v.pageOVDebtOne";
import PdfPageOverviewFive from "./view/pdf.v.pageOverviewFive";
import PdfPageOverviewFour from "./view/pdf.v.pageOverviewFour";
import PdfPageOverviewOne from "./view/pdf.v.pageOverviewOne";
import PdfPageOverviewSix from "./view/pdf.v.pageOverviewSix";
import PdfPageOverviewThree from "./view/pdf.v.pageOverviewThree";
import PdfPageOverviewTwo from "./view/pdf.v.pageOverviewTwo";
import PdfPageOVExpenseOne from "./view/pdf.v.pageOVExpenseOne";
import PdfPageOVIncomeOne from "./view/pdf.v.pageOVIncomeOne";
import PdfPageOVPropertyOne from "./view/pdf.v.pageOVPropertyOne";
import PdfPageRetireOne from "./view/pdf.v.pageRetireOne";
import PdfPageRetireThree from "./view/pdf.v.pageRetireThree";
import PdfPageRetireTwo from "./view/pdf.v.pageRetireTwo";
import PdfPageRiskOne from "./view/pdf.v.pageRiskOne";
import PdfPageSavingOne from "./view/pdf.v.pageSavingOne";
import PdfPageRiskTwo from "./view/pdf.v.pageRiskTwo";
import PdfPageRetireFour from "./view/pdf.v.pageRetireFour";

const PDFPreviewer = () => {
  const [pdfDataUri, setPdfDataUri] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const balanceData = useBalanceStore((state) => state.balanceData);
  const userData = useUserStore((state) => state.userData);
  const taxData = useTaxStore((state) => state.taxData);
  const futurePlanData = useFuturePlanStore((state) => state.futurePlanData);
  const educationData = useEducationStore((state) => state.educationData);
  const retireData = useRetireStore((state) => state.retireData);
  const debtData = useDebtStore((state) => state.debtData);
  const insuranceData = useInsuranceStore((state) => state.insuranceData);
  const investData = useInvestStore((state) => state.investData);

  const investItems = useMemo(() => {
    const DebtInvestLists = balanceData?.debt_long_list
      ?.map((item) => {
        if (item?.options_debt_long === "debt_long_other") {
          let tempOthers = item.debt_long_others?.flat();
          tempOthers = tempOthers?.map((other) => ({
            ...other,
            options_debt_long: "debt_long_other",
          }));
          return tempOthers;
        }

        if (item?.options_debt_long === "debt_place") {
          let tempPlaces = item.debt_long_places?.flat();
          tempPlaces = tempPlaces?.map((place) => ({
            ...place,
            options_debt_long: "debt_place",
          }));
          return tempPlaces;
        }

        if (item?.options_debt_long === "debt_car") {
          let tempCars = item.debt_long_cars?.flat();
          tempCars = tempCars?.map((car) => ({
            ...car,
            options_debt_long: "debt_car",
          }));
          return tempCars;
        }
        return null;
      })
      ?.flat()
      .filter((item) => item?.personal_or_investment === "investment")
      .filter((item) => item?.target_invest?.label === "อื่น ๆ");

    if (
      !balanceData?.property_invest_list?.length &&
      DebtInvestLists?.length === 0
    )
      return [];

    const filterPropertyInvest = balanceData?.property_invest_list?.filter(
      (item) => item?.options_property_invest_category
    );

    const groupInvest = _.groupBy(
      filterPropertyInvest,
      "options_property_invest_category"
    );

    let totalGlobal = 0;
    const convertGroupInvest = Object.keys(groupInvest)?.map((key) => {
      const items = [];
      groupInvest[key].forEach((curr) => {
        const itemKeys = Object.keys(curr);
        for (const itemKey of itemKeys) {
          const itemValue = curr[itemKey];
          if (_.isArray(itemValue)) {
            const total = itemValue?.reduce((prev, curr) => {
              return prev + curr.amount;
            }, 0);
            const merge = itemValue
              .filter(
                (thisItem) =>
                  thisItem?.target_invest?.value === "property_invest_other"
              )
              ?.map((thisItem) => {
                totalGlobal += thisItem?.amount;
                return {
                  ...thisItem,
                  label: thisItem?.title,
                  value: (thisItem?.amount / total) * 100,
                  // color: curr?.color,
                };
              });
            items.push(...merge);
          }
        }
      });
      return {
        key,
        label: key_property_invest_category[key],
        items,
      };
    });

    // MERGE ITEMS
    let mergeItems = [];
    for (const convertGroupInvestItem of convertGroupInvest) {
      mergeItems.push(
        convertGroupInvestItem.items?.map((item) => {
          return {
            ...item,
            title: convertGroupInvestItem.label,
            value: (item?.amount / totalGlobal) * 100,
            color: item?.color,
          };
        })
      );
    }

    if (DebtInvestLists && Array.isArray(DebtInvestLists)) {
      for (const DebtInvestList of DebtInvestLists) {
        let nameMapHeader = {
          debt_place: "อสังหาริมทรัพย์",
          debt_car: "ยานพาหนะ",
          debt_long_other: "อื่นๆ",
        };
        mergeItems.push({
          color: getRandomHexColor(),
          amount: DebtInvestList.current_price,
          reward_amount_per_year: DebtInvestList.return_interest,
          title:
            nameMapHeader[DebtInvestList?.options_debt_long] || "การลงทุนอื่นๆ",
          label:
            DebtInvestList.title ||
            DebtInvestList.address_place ||
            DebtInvestList.registration_car,
          value: (DebtInvestList?.current_price / totalGlobal) * 100,
        });
      }
    }
    return mergeItems;
  }, [balanceData]);

  const totalTaxDeduct = TaxHeirachyPDF(taxData)
    .filter((item) => {
      if (item?.title === "เงินสะสมกองทุนสำรองเลี้ยงชีพ") {
        return true;
      }
      return !ExceptionLists.includes(item?.title);
    })
    ?.reduce((sum, item) => {
      if (item?.title === "เงินสะสมกองทุนสำรองเลี้ยงชีพ") {
        if (item?.value2 >= 10000) {
          return sum + 10000;
        } else {
          return sum + item?.value2;
        }
      }
      return sum + item?.value2;
    }, 0);

  const totalException = TaxHeirachyPDF(taxData)
    .filter((item) => {
      if (item?.title === "เงินสะสมกองทุนสำรองเลี้ยงชีพ") {
        return true;
      }
      return ExceptionLists.includes(item?.title);
    })
    ?.reduce((sum, item) => {
      if (item?.title === "เงินสะสมกองทุนสำรองเลี้ยงชีพ") {
        if (item?.value2 >= 10000) {
          return sum + Number(item?.value2 || 0) - 10000;
        } else {
          return sum + Number(item?.value2 || 0);
        }
      }
      return sum + Number(item?.value2 || 0);
    }, 0);

  const debtShortItems = useMemo(() => {
    // console.log("1")
    const newDebtShortItems = [];

    if (balanceData?.debt_short_list?.length > 0) {
      for (const debt_short_item of balanceData?.debt_short_list) {
        const keys = Object.keys(debt_short_item);
        for (const key of keys) {
          if (_.isArray(debt_short_item[key])) {
            for (const item of debt_short_item[key]) {
              let createItem = {
                ...debt_short_item,
                ...item,
                title: "",
                unpaid_amount: item?.unpaid_amount,
                pay_permonth: item?.pay_permonth,
                interest: item?.interest,
                period: item?.period,
                period_time: "",
                type_payment: "",
                type_payment_ori: item?.type_payment,
                label: item?.creditor_name,
                status: options_debt?.find(
                  (option) => option?.value === item?.status
                ),
                unit_interest: "ต่อปี",
                sort: 0,
                customAmountOfInterest:
                  debt_short_item?.options_debt_short ===
                  "debt_informal_shortterm"
                    ? item?.start_amount * (item?.interest / 100)
                    : item?.unpaid_amount * (item?.interest / 100),
              };

              // เครดิตการ์ด
              if (debt_short_item?.options_debt_short === "debt_creditcard") {
                const creditor = calDebtCreditCard(item);
                const period = creditor?.creditor_items?.length;
                const typePayment = !item?.type_payment
                  ? ""
                  : item?.type_payment === "pay_minimum"
                  ? "จ่ายขั้นต่ำ(รายเดือน)"
                  : item?.type_payment === "pay_full"
                  ? "จ่ายเต็มจำนวน"
                  : "จ่ายแบบระบุจำนวน(รายเดือน)";
                createItem.period = !item?.type_payment ? "" : period;
                createItem.period_time = !item?.type_payment
                  ? ""
                  : formatPeriodTime(period);
                createItem.type_payment = typePayment;
                createItem.title = "บัตรเครดิต";
                createItem.sort = 1;
                createItem.customAmountOfInterest =
                  item?.type_payment === "pay_full"
                    ? 0
                    : creditor?.total_creditor_interest;
              }

              if (debt_short_item?.options_debt_short === "debt_shortterm") {
                const loanDetails = generateAmortizationSchedule(
                  item.unpaid_amount,
                  item.interest,
                  item.pay_permonth
                );

                const totalInterest = loanDetails?.reduce((acc, item) => {
                  return acc + item?.interestPayment;
                }, 0);
                createItem.customAmountOfInterest = totalInterest;
                createItem.sort = 2;
                createItem.type_payment = "รายเดือน";
              } else if (
                debt_short_item?.options_debt_short ===
                "debt_informal_shortterm"
              ) {
                createItem.sort = 3;
                createItem.title = "หนี้นอกระบบ (รายวัน)";
                createItem.type_payment = "รายวัน";
                createItem.period = `${item?.number_of_days} วัน`;
              } else if (
                debt_short_item?.options_debt_short === "debt_shortterm_other"
              ) {
                const creditor = calTotalCreditorFloatInterest(item);
                const totalCreditorInterest = creditor?.reduce(
                  (acc, item, index) => {
                    if (index > 11) {
                      return acc;
                    }
                    return acc + item.interest;
                  },
                  0
                );
                createItem.customAmountOfInterest = totalCreditorInterest;
                createItem.sort = 4;
                createItem.type_payment = "รายเดือน";
                createItem.unit_interest = "ต่อเดือน";
              }

              // เงินกู้ระยะสั้น, หนี้นอกระบบ, เงินกู้ระยะสั้นอื่นๆ
              if (
                [
                  "debt_shortterm",
                  "debt_informal_shortterm",
                  "debt_shortterm_other",
                ].includes(debt_short_item?.options_debt_short)
              ) {
                if (debt_short_item?.options_debt_short === "debt_shortterm") {
                  createItem.title = "หนี้กู้ระยะสั้น";
                } else if (
                  debt_short_item?.options_debt_short ===
                  "debt_informal_shortterm"
                ) {
                  createItem.title = "หนี้นอกระบบ";
                }
                createItem.period_time = formatPeriodTime(item?.period);
              }

              if (
                debt_short_item?.options_debt_short ===
                "debt_informal_shortterm"
              ) {
                createItem.unpaid_amount = item?.start_amount;
              }
              newDebtShortItems.push(createItem);
            }
          }
        }
      }
    }

    return newDebtShortItems.sort((a, b) => a.sort - b.sort);
  }, [balanceData]);

  const chunkDebtShortItems = useMemo(() => {
    const creditShortItems =
      balanceData?.debt_short_list?.filter(
        (item) => item?.options_debt_short === "debt_creditcard"
      ) || [];
    const splitCreditShortItems = creditShortItems?.flatMap((item) => {
      const chunkCreditItems = _.chunk(item?.credit_cards, 1);
      const newShortItems = chunkCreditItems?.map((creditItem) => {
        return {
          ...item,
          options_debt_short: "debt_creditcard",
          credit_cards: creditItem,
        };
      });
      return newShortItems;
    });
    const shortTermShortItems =
      balanceData?.debt_short_list?.filter(
        (item) => item?.options_debt_short === "debt_shortterm"
      ) || [];
    const splitShortTermShortItems = shortTermShortItems?.flatMap((item) => {
      const chunkShortTermItems = _.chunk(item?.short_terms, 1);
      const newShortItems = chunkShortTermItems?.map((shortItem) => {
        return {
          ...item,
          options_debt_short: "debt_shortterm",
          short_terms: shortItem,
        };
      });
      return newShortItems;
    });
    const informalShortItems =
      balanceData?.debt_short_list?.filter(
        (item) => item?.options_debt_short === "debt_informal_shortterm"
      ) || [];
    const splitInformalShortItems = informalShortItems?.flatMap((item) => {
      const chunkInformalShortItems = _.chunk(item?.informal_short_terms, 1);
      const newShortItems = chunkInformalShortItems?.map((informalItem) => {
        return {
          ...item,
          options_debt_short: "debt_informal_shortterm",
          informal_short_terms: informalItem,
        };
      });
      return newShortItems;
    });
    const otherShortItems =
      balanceData?.debt_short_list?.filter(
        (item) => item?.options_debt_short === "debt_shortterm_other"
      ) || [];
    const splitOtherShortItems = otherShortItems?.flatMap((item) => {
      const chunkOtherShortItems = _.chunk(item?.short_term_others, 1);
      const newShortItems = chunkOtherShortItems?.map((otherItem) => {
        return {
          ...item,
          options_debt_short: "debt_shortterm_other",
          short_term_others: otherItem,
        };
      });
      return newShortItems;
    });
    const carLongItems =
      balanceData?.debt_long_list?.filter(
        (item) => item?.options_debt_long === "debt_car"
      ) || [];
    const splitCarLongItems = carLongItems?.flatMap((item) => {
      const chunkCarLongItems = _.chunk(item?.debt_long_cars, 1);
      const newLongItems = chunkCarLongItems?.map((carItem) => {
        return {
          ...item,
          options_debt_long: "debt_car",
          debt_long_cars: carItem,
        };
      });
      return newLongItems;
    });
    const placeLongItems =
      balanceData?.debt_long_list?.filter(
        (item) => item?.options_debt_long === "debt_place"
      ) || [];
    const splitPlaceLongItems = placeLongItems?.flatMap((item) => {
      const chunkPlaceLongItems = _.chunk(item?.debt_long_places, 1);
      const newLongItems = chunkPlaceLongItems?.map((placeItem) => {
        return {
          ...item,
          options_debt_long: "debt_place",
          debt_long_places: placeItem,
        };
      });
      return newLongItems;
    });
    const otherLongItems =
      balanceData?.debt_long_list?.filter(
        (item) => item?.options_debt_long === "debt_long_other"
      ) || [];
    const splitOtherLongItems = otherLongItems?.flatMap((item) => {
      const chunkOtherLongItems = _.chunk(item?.debt_long_others, 1);
      const newLongItems = chunkOtherLongItems?.map((otherItem) => {
        return {
          ...item,
          options_debt_long: "debt_long_other",
          debt_long_others: otherItem,
        };
      });
      return newLongItems;
    });
    const newChunkDebtItems = _.chunk(
      [
        ...splitCreditShortItems,
        ...splitShortTermShortItems,
        ...splitInformalShortItems,
        ...splitOtherShortItems,
        ...splitCarLongItems,
        ...splitPlaceLongItems,
        ...splitOtherLongItems,
      ],
      2
    );
    return newChunkDebtItems;
  }, [balanceData]);

  // Refactor: Memoize allPages to avoid heavy computation on every render
  const allPages = useMemo(() => {
    let pages = [
      <PdfPageOverviewOne page={1} userData={userData} />,
      <PdfPageOverviewTwo
        page={2}
        insuranceData={insuranceData}
        educationData={educationData}
      />,
      <PdfPageOverviewThree
        page={3}
        futurePlanData={futurePlanData}
        educationData={educationData}
        balanceData={balanceData}
        debtData={debtData}
      />,
      <PdfPageOverviewFour page={4} balanceData={balanceData} />,
      <PdfPageOverviewFive page={5} />,
      <PdfPageOverviewSix page={6} />,

      <PdfPageAssumeOne page={7} />,
      <PdfPageOVIncomeOne page={8} />,
      <PdfPageOVExpenseOne page={9} />,
      <PdfPageOVPropertyOne page={10} />,
      <PdfPageOVDebtOne page={11} />,

      // งบดุล
      <PdfPageBalananceOne page={12} />,
      <PdfPageBalananceTwo page={13} />,
      <PdfPageBalananceThree page={14} />,

      // รายรับ-รายจ่าย
      <PdfPageBalananceFour page={15} />,
      <PdfPageBalananceFourExtra page={16} />,
      <PdfPageBalananceFive page={13} />,
      <PdfPageBalananceSix page={14} />,
      <PdfPageBalananceEight page={15} />,

      <PdfPageFinacialOne page={16} />,

      // อัตราส่วนทางการเงิน
      <PdfPageFinacialTwo page={17} />,
      <PdfPageFinacialLanding page={18} />,

      // บริหารความเสี่ยง
      <PdfPageRiskOne page={19} balanceData={balanceData} />,
      <PdfPageRiskTwo
        page={20}
        order={1}
        balanceData={balanceData}
        insuranceData={insuranceData}
      />,
      <PdfPageRiskTwo
        page={20}
        order={2}
        balanceData={balanceData}
        insuranceData={insuranceData}
      />,
      <PdfPageFamilyOne page={20} />,
      <PdfPageFamilyTwo page={21} />,
      <PdfPageFamilyThree page={22} />,

      <PdfPageRetireOne
        page={23}
        retireData={retireData}
        educationData={educationData}
      />,
      <PdfPageRetireTwo page={24} />,
      <PdfPageRetireThree page={25} userData={userData} />,
      <PdfPageRetireFour page={25} userData={userData} />,
      <IncomeProfilePdf
        page={26}
        taxData={taxData?.RMF_Profit}
        userData={userData}
      />,
      <SalaryIncomePdf
        page={27}
        userData={userData}
        taxData={taxData}
        balanceData={balanceData}
      />,
    ];

    //ภาษี
    if (taxData?.tax_QuitJob?.isQuitJob) {
      pages.push(
        <QuitJobIncomePdf page={28} userData={userData} taxData={taxData} />
      );
    }

    pages = [
      ...pages,
      <Income402Pdf
        page={28}
        userData={userData}
        taxData={taxData}
        balanceData={balanceData}
      />,
    ];

    Income406PerPage(
      taxData?.freeJob,
      balanceData?.other_income_list?.filter(
        (item, index) => item?.option_income_other === "special_profession"
      ) || []
    )?.forEach((item, index) => {
      pages.push(
        <Income406Pdf
          page={29}
          isFirst={index === 0}
          isLast={
            Income406PerPage(
              taxData?.freeJob,
              balanceData?.other_income_list?.filter(
                (item, index) =>
                  item?.option_income_other === "special_profession"
              ) || []
            )?.length ===
              index + 1 &&
            (taxData?.freeJob
              ?.map((item) => item?.calculating_method)
              ?.includes("หักตามจริง") ||
              balanceData?.other_income_list
                ?.filter(
                  (item, index) =>
                    item?.option_income_other === "special_profession"
                )
                ?.map((item) => item?.calculating_method)
                ?.includes("หักตามจริง"))
          }
          userData={userData}
          taxData={taxData}
          datalist={item}
        />
      );
    });

    Income403PerPage(
      taxData?.tax_403,
      balanceData?.other_income_list?.filter(
        (item, index) => item?.option_income_other === "copy_right"
      ) || []
    )?.forEach((item, index) => {
      if (
        index === 0 &&
        Income403PerPage(
          taxData?.tax_403,
          balanceData?.other_income_list?.filter(
            (item, index) => item?.option_income_other === "copy_right"
          ) || []
        )?.length ===
          index + 1 &&
        (taxData?.freeJob
          ?.map((item) => item?.calculating_method)
          ?.includes("หักตามจริง") ||
          balanceData?.other_income_list
            ?.filter(
              (item, index) => item?.option_income_other === "copy_right"
            )
            ?.map((item) => item?.calculating_method)
            ?.includes("หักตามจริง"))
      ) {
        pages.push(
          <Income403Pdf
            page={30}
            isFirst={index === 0}
            userData={userData}
            taxData={taxData}
            datalist={item}
          />
        );
        pages.push(
          <Income403Pdf
            page={30}
            isLast={
              Income403PerPage(
                taxData?.tax_403,
                balanceData?.other_income_list?.filter(
                  (item, index) => item?.option_income_other === "copy_right"
                ) || []
              )?.length ===
                index + 1 &&
              (taxData?.freeJob
                ?.map((item) => item?.calculating_method)
                ?.includes("หักตามจริง") ||
                balanceData?.other_income_list
                  ?.filter(
                    (item, index) => item?.option_income_other === "copy_right"
                  )
                  ?.map((item) => item?.calculating_method)
                  ?.includes("หักตามจริง"))
            }
            userData={userData}
            taxData={taxData}
            datalist={[]}
          />
        );
      }
      pages.push(
        <Income403Pdf
          page={30}
          isFirst={index === 0}
          isLast={
            Income403PerPage(
              taxData?.tax_403,
              balanceData?.other_income_list?.filter(
                (item, index) => item?.option_income_other === "copy_right"
              ) || []
            )?.length ===
              index + 1 &&
            (taxData?.freeJob
              ?.map((item) => item?.calculating_method)
              ?.includes("หักตามจริง") ||
              balanceData?.other_income_list
                ?.filter(
                  (item, index) => item?.option_income_other === "copy_right"
                )
                ?.map((item) => item?.calculating_method)
                ?.includes("หักตามจริง"))
          }
          userData={userData}
          taxData={taxData}
          datalist={item}
        />
      );
    });

    Income405PerPage(
      taxData?.tax_405,
      balanceData?.other_income_list?.filter(
        (item, index) => item?.option_income_other === "other_rent_nonviolence"
      ) || []
    )?.forEach((item, index) => {
      pages.push(
        <Income405Pdf
          page={31}
          isFirst={index === 0}
          isLast={
            Income405PerPage(
              taxData?.tax_405,
              balanceData?.other_income_list?.filter(
                (item, index) =>
                  item?.option_income_other === "other_rent_nonviolence"
              ) || []
            )?.length ===
              index + 1 &&
            (taxData?.freeJob
              ?.map((item) => item?.calculating_method)
              ?.includes("หักตามจริง") ||
              balanceData?.other_income_list
                ?.filter(
                  (item, index) =>
                    item?.option_income_other === "other_rent_nonviolence"
                )
                ?.map((item) => item?.calculating_method)
                ?.includes("หักตามจริง"))
          }
          userData={userData}
          taxData={taxData}
          datalist={item}
        />
      );
    });

    Income407PerPage(
      taxData?.tax_407,
      balanceData?.other_income_list?.filter(
        (item, index) => item?.option_income_other === "contract_business"
      ) || []
    )?.forEach((item, index) => {
      pages.push(
        <Income407Pdf
          page={32}
          isFirst={index === 0}
          isLast={
            Income407PerPage(
              taxData?.tax_407,
              balanceData?.other_income_list?.filter(
                (item, index) =>
                  item?.option_income_other === "contract_business"
              ) || []
            )?.length ===
              index + 1 &&
            (taxData?.tax_407
              ?.map((item) => item?.calculating_method)
              ?.includes("หักตามจริง") ||
              balanceData?.other_income_list
                ?.filter(
                  (item, index) =>
                    item?.option_income_other === "contract_business"
                )
                ?.map((item) => item?.calculating_method)
                ?.includes("หักตามจริง"))
          }
          userData={userData}
          taxData={taxData}
          datalist={item}
        />
      );
    });

    Income408PerPage(
      taxData?.tax_408,
      balanceData?.other_income_list?.filter(
        (item, index) => item?.option_income_other === "other_income_other"
      ) || []
    )?.forEach((item, index) => {
      if (
        Income408PerPage(
          taxData?.tax_408,
          balanceData?.other_income_list?.filter(
            (item, index) => item?.option_income_other === "other_income_other"
          ) || []
        )?.length ===
          index + 1 &&
        index === 0 &&
        taxData?.tax_408
          ?.map((item) => item?.calculating_method)
          ?.includes("หักตามจริง")
      ) {
        pages.push(
          <Income408Pdf
            page={33}
            isFirst={index === 0}
            isLast={false}
            userData={userData}
            taxData={taxData}
            datalist={item}
          />
        );
        pages.push(
          <Income408Pdf
            page={33}
            isLast={
              Income408PerPage(
                taxData?.tax_408,
                balanceData?.other_income_list?.filter(
                  (item, index) =>
                    item?.option_income_other === "other_income_other"
                ) || []
              )?.length ===
                index + 1 &&
              (taxData?.tax_408
                ?.map((item) => item?.calculating_method)
                ?.includes("หักตามจริง") ||
                balanceData?.other_income_list
                  ?.filter(
                    (item, index) =>
                      item?.option_income_other === "other_income_other"
                  )
                  ?.map((item) => item?.calculating_method)
                  ?.includes("หักตามจริง"))
            }
            userData={userData}
            taxData={taxData}
            datalist={[]}
          />
        );
      }

      pages.push(
        <Income408Pdf
          page={33}
          isFirst={index === 0}
          isLast={
            Income408PerPage(
              taxData?.tax_408,
              balanceData?.other_income_list?.filter(
                (item, index) =>
                  item?.option_income_other === "other_income_other"
              )
            )?.length ===
              index + 1 &&
            (taxData?.tax_408
              ?.map((item) => item?.calculating_method)
              ?.includes("หักตามจริง") ||
              balanceData?.other_income_list
                ?.filter(
                  (item, index) =>
                    item?.option_income_other === "other_income_other"
                )
                ?.map((item) => item?.calculating_method)
                ?.includes("หักตามจริง"))
          }
          userData={userData}
          taxData={taxData}
          datalist={item}
        />
      );
    });

    Income408PropertyPerPage(
      taxData?.tax_408_property,
      balanceData?.other_income_list?.filter(
        (item, index) => item?.option_income_other === "other_income_selling"
      ) || []
    )?.forEach((item, index) => {
      pages.push(
        <Income408property
          page={34}
          isFirst={index === 0}
          isLast={
            Income408PerPage(taxData?.tax_408_property)?.length === index + 1 &&
            index !== 0 &&
            (taxData?.freeJob
              ?.map((item) => item?.calculating_method)
              ?.includes("หักตามจริง") ||
              balanceData?.other_income_list
                ?.filter(
                  (item, index) =>
                    item?.option_income_other === "contract_business"
                )
                ?.map((item) => item?.calculating_method)
                ?.includes("หักตามจริง"))
          }
          userData={userData}
          taxData={taxData}
          datalist={item}
        />
      );
    });

    Income404PerPage(
      taxData?.tax_404,
      balanceData?.interest_peryear_list || [],
      balanceData?.other_income_list?.filter(
        (item) => item?.option_income_other === "other_dividend"
      ) || []
    )?.forEach((item, index) => {
      pages.push(
        <Income404Pdf
          page={35}
          isFirst={index === 0}
          isLast={false}
          userData={userData}
          taxData={taxData}
          datalist={item}
        />
      );
    });

    Income404StockPerPage(taxData?.tax_404_stock)?.forEach((item, index) => {
      pages.push(
        <Income408StockPdf
          page={36}
          isFirst={index === 0}
          isLast={
            Income408PerPage(taxData?.tax_404_stock)?.length === index + 1 &&
            taxData?.freeJob
              ?.map((item) => item?.calculating_method)
              ?.includes("หักตามจริง")
          }
          userData={userData}
          taxData={taxData}
          datalist={item}
          allList={taxData?.tax_404_stock}
        />
      );
    });

    if (taxData?.income_not_include_tax > 0) {
      pages.push(<IncomeTaxNotIncludePdf page={37} taxData={taxData} />);
    }

    pages = [
      ...pages,
      <IncomeRMFPdf page={37} taxData={taxData?.RMF_Profit} />,
      // <IncomeSSFPdf page={38} taxData={taxData?.SSF_Profit} />,
      <Income408Recive page={39} taxData={taxData} />,
    ];

    if (taxData?.heritage?.isPropertyDetail) {
      Income408ReciveDetailFunction(taxData?.heritage?.propertyDetail)?.forEach(
        (item, index) => {
          pages.push(<Income408ReciveDetail page={39} allList={item} />);
        }
      );
    }

    pages.push(
      <TaxDeductionPDF
        page={39}
        dataLength={TaxHeirachy(taxData)?.length}
        dataLengthLimit={10}
        data={TaxHeirachy(taxData)
          ?.filter((item) => item?.title !== "กองทุน กบข.")
          ?.sort((a, b) => a.sort - b.sort)
          ?.slice(0, 10)}
        head_1="จำนวนเงินที่ระบุ"
        total={totalTaxDeduct}
        totalException={totalException}
      />
    );

    if (TaxHeirachy(taxData)?.length > 10) {
      pages.push(
        <TaxDeductionPDF
          page={39}
          dataLength={TaxHeirachy(taxData)?.length}
          dataLengthLimit={20}
          data={TaxHeirachy(taxData)
            ?.filter((item) => item?.title !== "กองทุน กบข.")
            ?.sort((a, b) => a.sort - b.sort)
            ?.slice(10, 18)}
          head_1="จำนวนเงินที่ระบุ"
          total={totalTaxDeduct}
          totalException={totalException}
        />
      );
    }

    if (TaxHeirachy(taxData)?.length > 18) {
      pages.push(
        <TaxDeductionPDF
          page={39}
          dataLengthLimit={24}
          data={TaxHeirachy(taxData)
            ?.filter((item) => item?.title !== "กองทุน กบข.")
            ?.sort((a, b) => a.sort - b.sort)
            ?.slice(18)}
          head_1="จำนวนเงินที่ระบุ"
          total={totalTaxDeduct}
          totalException={totalException}
        />
      );
    }

    pages = [
      ...pages,
      <TaxExceptionPDF
        page={39}
        data={TaxHeirachy(taxData)?.sort((a, b) => a.sort - b.sort)}
        title="ค่ายกเว้นก่อนวางแผน"
        head_1="จำนวนเงินที่ระบุ"
        total={totalTaxDeduct}
        totalException={totalException}
      />,

      <TaxDeductionPDF
        page={40}
        title={"ค่าลดหย่อนหลังวางแผน"}
        dataLength={TaxHeirachy(taxData, () => {}, "four")?.length}
        dataLengthLimit={10}
        data={TaxHeirachy(taxData, () => {}, "four")
          ?.filter((item) => item?.title !== "กองทุน กบข.")
          ?.sort((a, b) => a.sort - b.sort)
          ?.slice(0, 10)}
        head_1="จำนวนเงินที่ระบุ"
        total={DeductionSumPDF(taxData)}
        totalException={ExceptionSumPDF(taxData)}
      />,
    ];

    if (TaxHeirachy(taxData, () => {}, "four")?.length > 10) {
      pages.push(
        <TaxDeductionPDF
          page={40}
          dataLength={TaxHeirachy(taxData, () => {}, "four")?.length}
          dataLengthLimit={20}
          data={TaxHeirachy(taxData, () => {}, "four")
            ?.filter((item) => item?.title !== "กองทุน กบข.")
            ?.sort((a, b) => a.sort - b.sort)
            ?.slice(10, 18)}
          head_1="จำนวนเงินที่ระบุ"
          total={DeductionSumPDF(taxData)}
          totalException={ExceptionSumPDF(taxData)}
        />
      );
    }

    if (TaxHeirachy(taxData, () => {}, "four")?.length > 18)
      pages.push(
        <TaxDeductionPDF
          page={40}
          dataLengthLimit={24}
          data={TaxHeirachy(taxData, () => {}, "four")
            ?.filter((item) => item?.title !== "กองทุน กบข.")
            ?.sort((a, b) => a.sort - b.sort)
            ?.slice(18)}
          head_1="จำนวนเงินที่ระบุ"
          total={DeductionSumPDF(taxData)}
          totalException={ExceptionSumPDF(taxData)}
        />
      );

    pages = [
      ...pages,
      <TaxExceptionPDF
        title="ค่ายกเว้นก่อนวางแผน"
        page={40}
        data={TaxHeirachy(taxData, () => {}, "four")?.sort(
          (a, b) => a.sort - b.sort
        )}
        head_1="จำนวนเงินที่ระบุ"
        total={DeductionSumPDF(taxData)}
        totalException={ExceptionSumPDF(taxData)}
      />,
      <IncomeResultPDF
        page={41}
        taxData={taxData}
        userData={userData}
        balanceData={balanceData}
      />,
    ];

    if (investItems?.length !== 0) {
      pages.push(<PdfPageInvestOne page={42} />);
    }

    const sortItems = [
      {
        label: "ตราสารทุน",
      },
      {
        label: "ตราสารหนี้",
      },
      {
        label: "ตลาดเงิน",
      },
      {
        label: "เงินฝาก",
      },
      {
        label: "สินทรัพย์ทางเลือก",
      },
    ];

    const temp_PdfPageInvestTwo_Items = sortItems
      ?.map((sortItem, index) => {
        const findItem = PdfPageInvestTwo_Items(balanceData)?.find(
          (item) => item?.label === sortItem?.label
        );
        return findItem;
      })
      ?.filter((item) => item !== undefined);

    if (
      Array.isArray(temp_PdfPageInvestTwo_Items) &&
      temp_PdfPageInvestTwo_Items.length > 0
    ) {
      for (
        let indexOutside = 0;
        indexOutside < temp_PdfPageInvestTwo_Items.length;
        indexOutside++
      ) {
        const itemInvestTwo = temp_PdfPageInvestTwo_Items[indexOutside];

        pages.push(
          <PdfPageInvestTwo
            page={42}
            itemInvestTwo={itemInvestTwo}
            indexOutside={indexOutside}
            keyInvest={itemInvestTwo.key}
          />
        );
      }
    }

    if (investItems?.length !== 0) {
      const investItemsThree = () => {
        const DebtInvestLists = balanceData?.debt_long_list
          ?.map((item) => {
            if (item?.options_debt_long === "debt_long_other") {
              let tempOthers = item.debt_long_others?.flat();
              tempOthers = tempOthers?.map((other) => ({
                ...other,
                options_debt_long: "debt_long_other",
              }));
              return tempOthers;
            }

            if (item?.options_debt_long === "debt_place") {
              let tempPlaces = item.debt_long_places?.flat();
              tempPlaces = tempPlaces?.map((place) => ({
                ...place,
                options_debt_long: "debt_place",
              }));
              return tempPlaces;
            }

            if (item?.options_debt_long === "debt_car") {
              let tempCars = item.debt_long_cars?.flat();
              tempCars = tempCars?.map((car) => ({
                ...car,
                options_debt_long: "debt_car",
              }));
              return tempCars;
            }
            return null;
          })
          ?.flat()
          .filter((item) => item?.personal_or_investment === "investment")
          .filter((item) => item?.target_invest?.label === "เพื่อการเกษียณ");

        if (
          !balanceData?.property_invest_list?.length &&
          DebtInvestLists?.length === 0
        )
          return [];

        const filterPropertyInvest = balanceData?.property_invest_list?.filter(
          (item) => item?.options_property_invest_category
        );

        const groupInvest = _.groupBy(
          filterPropertyInvest,
          "options_property_invest_category"
        );

        let totalGlobal = Object.keys(groupInvest)
          ?.map((key) => {
            let tempTotal = 0;
            groupInvest[key].forEach((curr) => {
              const itemKeys = Object.keys(curr);
              for (const itemKey of itemKeys) {
                const itemValue = curr[itemKey];
                if (_.isArray(itemValue)) {
                  tempTotal = itemValue?.reduce((prev, curr) => {
                    return prev + curr.amount;
                  }, 0);
                }
              }
            });
            return tempTotal;
          })
          ?.reduce((prev, curr) => prev + curr, 0);

        totalGlobal += DebtInvestLists?.reduce((prev, curr) => {
          return prev + Number(curr?.current_price || 0);
        }, 0);

        const convertGroupInvest = Object.keys(groupInvest)?.map((key) => {
          const items = [];
          groupInvest[key].forEach((curr) => {
            const itemKeys = Object.keys(curr);
            for (const itemKey of itemKeys) {
              const itemValue = curr[itemKey];
              if (_.isArray(itemValue)) {
                const merge = itemValue
                  .filter(
                    (thisItem) =>
                      thisItem?.target_invest?.value ===
                      "property_invest_retirement"
                  )
                  ?.map((thisItem) => {
                    // totalGlobal += thisItem?.amount;
                    return {
                      ...thisItem,
                      label: thisItem?.title,
                      value: (thisItem?.amount / totalGlobal) * 100,
                    };
                  });
                items.push(...merge);
              }
            }
          }, []);
          return {
            key,
            label: key_property_invest_category[key],
            items,
          };
        });

        // MERGE ITEMS
        let mergeItems = [];
        for (const convertGroupInvestItem of convertGroupInvest) {
          mergeItems.push(
            ...convertGroupInvestItem.items?.map((item) => {
              return {
                ...item,
                title: convertGroupInvestItem.label,
                value: (item?.amount / totalGlobal) * 100,
              };
            })
          );
        }

        // Make sure DebtInvestLists is iterable before looping through it
        if (DebtInvestLists && Array.isArray(DebtInvestLists)) {
          for (const DebtInvestList of DebtInvestLists) {
            let nameMapHeader = {
              debt_place: "อสังหาริมทรัพย์",
              debt_car: "ยานพาหนะ",
              debt_long_other: "อื่นๆ",
            };
            mergeItems.push({
              color: getRandomHexColor(),
              amount: DebtInvestList?.current_price,
              reward_amount_per_year: DebtInvestList?.return_interest,
              title:
                nameMapHeader[DebtInvestList?.options_debt_long] ||
                "การลงทุนอื่นๆ",
              label:
                DebtInvestList?.title ||
                DebtInvestList?.address_place ||
                DebtInvestList?.registration_car,
              value: (DebtInvestList?.current_price / totalGlobal) * 100,
            });
          }
        }

        return mergeItems;
      };

      if (investItemsThree()?.length > 0) {
        pages = [
          ...pages,
          <PdfPageInvestThree
            page={44}
            balanceData={balanceData}
            investItemsThree={investItemsThree()}
          />,
        ];
      }

      const investItemsFour = () => {
        const DebtInvestLists = balanceData?.debt_long_list
          ?.map((item) => {
            if (item?.options_debt_long === "debt_long_other") {
              let tempOthers = item.debt_long_others?.flat();
              tempOthers = tempOthers?.map((other) => ({
                ...other,
                options_debt_long: "debt_long_other",
              }));
              return tempOthers;
            }

            if (item?.options_debt_long === "debt_place") {
              let tempPlaces = item.debt_long_places?.flat();
              tempPlaces = tempPlaces?.map((place) => ({
                ...place,
                options_debt_long: "debt_place",
              }));
              return tempPlaces;
            }

            if (item?.options_debt_long === "debt_car") {
              let tempCars = item.debt_long_cars?.flat();
              tempCars = tempCars?.map((car) => ({
                ...car,
                options_debt_long: "debt_car",
              }));
              return tempCars;
            }
            return null;
          })
          ?.flat()
          .filter((item) => item?.personal_or_investment === "investment")
          .filter((item) => item?.target_invest?.label === "เพื่อการศึกษาบุตร");

        if (
          !balanceData?.property_invest_list?.length &&
          DebtInvestLists?.length === 0
        )
          return [];

        const filterPropertyInvest = balanceData?.property_invest_list?.filter(
          (item) => item?.options_property_invest_category
        );

        const groupInvest = _.groupBy(
          filterPropertyInvest,
          "options_property_invest_category"
        );

        let totalGlobal = Object.keys(groupInvest)
          ?.map((key) => {
            let tempTotal = 0;
            groupInvest[key].forEach((curr) => {
              const itemKeys = Object.keys(curr);
              for (const itemKey of itemKeys) {
                const itemValue = curr[itemKey];
                if (_.isArray(itemValue)) {
                  tempTotal = itemValue?.reduce((prev, curr) => {
                    return prev + curr.amount;
                  }, 0);
                }
              }
            });
            return tempTotal;
          })
          ?.reduce((prev, curr) => prev + curr, 0);

        totalGlobal += DebtInvestLists?.reduce((prev, curr) => {
          return prev + Number(curr?.current_price || 0);
        }, 0);

        const convertGroupInvest = Object.keys(groupInvest)?.map((key) => {
          const items = [];
          groupInvest[key].forEach((curr) => {
            const itemKeys = Object.keys(curr);
            for (const itemKey of itemKeys) {
              const itemValue = curr[itemKey];
              if (_.isArray(itemValue)) {
                const merge = itemValue
                  .filter(
                    (thisItem) =>
                      thisItem?.target_invest?.value ===
                      "property_invest_education"
                  )
                  ?.map((thisItem) => {
                    // totalGlobal += thisItem?.amount;
                    return {
                      ...thisItem,
                      label: thisItem?.title,
                      value: (thisItem?.amount / totalGlobal) * 100,
                    };
                  });
                items.push(...merge);
              }
            }
          }, []);
          return {
            key,
            label: key_property_invest_category[key],
            items,
          };
        });

        // MERGE ITEMS
        let mergeItems = [];
        for (const convertGroupInvestItem of convertGroupInvest) {
          mergeItems.push(
            ...convertGroupInvestItem.items?.map((item) => {
              return {
                ...item,
                title: convertGroupInvestItem.label,
                value: (item?.amount / totalGlobal) * 100,
              };
            })
          );
        }

        // Make sure DebtInvestLists is iterable before looping through it
        if (DebtInvestLists && Array.isArray(DebtInvestLists)) {
          for (const DebtInvestList of DebtInvestLists) {
            let nameMapHeader = {
              debt_place: "อสังหาริมทรัพย์",
              debt_car: "ยานพาหนะ",
              debt_long_other: "อื่นๆ",
            };
            mergeItems.push({
              color: getRandomHexColor(),
              amount: DebtInvestList?.current_price,
              reward_amount_per_year: DebtInvestList?.return_interest,
              title:
                nameMapHeader[DebtInvestList?.options_debt_long] ||
                "การลงทุนอื่นๆ",
              label:
                DebtInvestList?.title ||
                DebtInvestList?.address_place ||
                DebtInvestList?.registration_car,
              value: (DebtInvestList?.current_price / totalGlobal) * 100,
            });
          }
        }

        return mergeItems;
      };

      if (investItemsFour()?.length > 0) {
        pages = [
          ...pages,
          <PdfPageInvestFour
            page={44}
            balanceData={balanceData}
            investData={investItemsFour()}
          />,
        ];
      }

      const investItemsFive = () => {
        const DebtInvestLists = balanceData?.debt_long_list
          ?.map((item) => {
            if (item?.options_debt_long === "debt_long_other") {
              let tempOthers = item.debt_long_others?.flat();
              tempOthers = tempOthers?.map((other) => ({
                ...other,
                options_debt_long: "debt_long_other",
              }));
              return tempOthers;
            }

            if (item?.options_debt_long === "debt_place") {
              let tempPlaces = item.debt_long_places?.flat();
              tempPlaces = tempPlaces?.map((place) => ({
                ...place,
                options_debt_long: "debt_place",
              }));
              return tempPlaces;
            }

            if (item?.options_debt_long === "debt_car") {
              let tempCars = item.debt_long_cars?.flat();
              tempCars = tempCars?.map((car) => ({
                ...car,
                options_debt_long: "debt_car",
              }));
              return tempCars;
            }
            return null;
          })
          ?.flat()
          .filter((item) => item?.personal_or_investment === "investment")
          .filter((item) => item?.target_invest?.label === "อื่น ๆ");

        if (
          !balanceData?.property_invest_list?.length &&
          DebtInvestLists?.length === 0
        )
          return [];

        const filterPropertyInvest = balanceData?.property_invest_list?.filter(
          (item) => item?.options_property_invest_category
        );

        const groupInvest = _.groupBy(
          filterPropertyInvest,
          "options_property_invest_category"
        );

        let totalGlobal = 0;
        const convertGroupInvest = Object.keys(groupInvest)?.map((key) => {
          const items = [];
          groupInvest[key].forEach((curr) => {
            const itemKeys = Object.keys(curr);
            for (const itemKey of itemKeys) {
              const itemValue = curr[itemKey];
              if (_.isArray(itemValue)) {
                const total = itemValue?.reduce((prev, curr) => {
                  return prev + curr.amount;
                }, 0);
                const merge = itemValue
                  .filter(
                    (thisItem) =>
                      thisItem?.target_invest?.value === "property_invest_other"
                  )
                  ?.map((thisItem) => {
                    totalGlobal += thisItem?.amount;
                    return {
                      ...thisItem,
                      label: thisItem?.title,
                      value: (thisItem?.amount / total) * 100,
                      // color: curr?.color,
                    };
                  });
                items.push(...merge);
              }
            }
          }, []);
          return {
            key,
            label: key_property_invest_category[key],
            items,
          };
        });

        // MERGE ITEMS
        let mergeItems = [];
        for (const convertGroupInvestItem of convertGroupInvest) {
          mergeItems.push(
            ...convertGroupInvestItem.items?.map((item) => {
              return {
                ...item,
                title: convertGroupInvestItem.label,
                value: (item?.amount / totalGlobal) * 100,
                color: item?.color,
              };
            })
          );
        }

        if (DebtInvestLists && Array.isArray(DebtInvestLists)) {
          for (const DebtInvestList of DebtInvestLists) {
            let nameMapHeader = {
              debt_place: "อสังหาริมทรัพย์",
              debt_car: "ยานพาหนะ",
              debt_long_other: "อื่นๆ",
            };
            mergeItems.push({
              color: getRandomHexColor(),
              amount: DebtInvestList.current_price,
              reward_amount_per_year: DebtInvestList.return_interest,
              title:
                nameMapHeader[DebtInvestList?.options_debt_long] ||
                "การลงทุนอื่นๆ",
              label:
                DebtInvestList.title ||
                DebtInvestList.address_place ||
                DebtInvestList.registration_car,
              value: (DebtInvestList?.current_price / totalGlobal) * 100,
            });
          }
        }
        return mergeItems;
      };

      if (investItemsFive()?.length > 0) {
        pages = [
          ...pages,
          <PdfPageInvestFive
            page={46}
            balanceData={balanceData}
            investData={investData}
          />,
        ];
      }
    }

    let tempEducation = educationData?.map((educationItem, index) => {
      return [
        <PdfPageEducationTwo page={1} educationItem={educationItem} />,
        <PdfPageEducationThree page={1} educationItem={educationItem} />,
      ];
    });

    tempEducation = tempEducation?.flat();

    pages = [...pages, ...tempEducation, <PdfPageSavingOne page={48} />];

    FutureHomeExpensePDF(futurePlanData?.expenese_home_items)?.forEach(
      (item, index) => {
        pages.push(
          <ExpenseFuturePDF
            page={37}
            isFirst={index === 0}
            isLast={
              FutureHomeExpensePDF(futurePlanData?.expenese_home_items)
                ?.length ===
              index + 1
            }
            userData={userData}
            taxData={taxData}
            datalist={item}
          />
        );
      }
    );

    FutureCarExpensePDF(futurePlanData?.expenese_car_items)?.forEach(
      (item, index) => {
        pages.push(
          <ExpenseFuturePDF
            page={37}
            isFirst={index === 0}
            isLast={
              FutureCarExpensePDF(futurePlanData?.expenese_car_items)
                ?.length ===
              index + 1
            }
            userData={userData}
            taxData={taxData}
            datalist={item}
          />
        );
      }
    );

    FutureChildrenExpensePDF(futurePlanData?.expenese_children_items)?.forEach(
      (item, index) => {
        pages.push(
          <ExpenseFuturePDF
            page={37}
            isFirst={index === 0}
            isLast={
              FutureChildrenExpensePDF(futurePlanData?.expenese_children_items)
                ?.length ===
              index + 1
            }
            userData={userData}
            taxData={taxData}
            datalist={item}
            ischileFuture={true}
          />
        );
      }
    );

    FutureTravelExpensePDF(futurePlanData?.expenese_travel_items)?.forEach(
      (item, index) => {
        pages.push(
          <ExpenseFuturePDF
            page={37}
            isFirst={index === 0}
            isLast={
              FutureTravelExpensePDF(futurePlanData?.expenese_travel_items)
                ?.length ===
              index + 1
            }
            userData={userData}
            taxData={taxData}
            datalist={item}
          />
        );
      }
    );

    FutureCollectionExpensePDF(
      futurePlanData?.expenese_collection_items
    )?.forEach((item, index) => {
      pages.push(
        <ExpenseFuturePDF
          page={37}
          isFirst={index === 0}
          isLast={
            FutureCollectionExpensePDF(
              futurePlanData?.expenese_collection_items
            )?.length ===
            index + 1
          }
          userData={userData}
          taxData={taxData}
          datalist={item}
        />
      );
    });

    FutureETCExpensePDF(futurePlanData?.expenese_other_items)?.forEach(
      (item, index) => {
        pages.push(
          <ExpenseFuturePDF
            page={37}
            isFirst={index === 0}
            isLast={
              FutureETCExpensePDF(futurePlanData?.expenese_other_items)
                ?.length ===
              index + 1
            }
            userData={userData}
            taxData={taxData}
            datalist={item}
          />
        );
      }
    );

    if (futurePlanData?.expenese_children_education?.length > 0) {
      ChildrenEducationExpensePDF(educationData)?.forEach((item, index) => {
        pages.push(
          <ExpenseFuturePDF
            page={37}
            isChildrenEducation={true}
            userData={userData}
            taxData={taxData}
            datalist={item}
          />
        );
      });
    }

    LegacyIncomePDF(futurePlanData?.income_legacy_items)?.forEach(
      (item, index) => {
        pages.push(
          <IncomeFuturePDF
            page={37}
            isFirst={index === 0}
            isLast={
              LegacyIncomePDF(futurePlanData?.income_legacy_items)?.length ===
              index + 1
            }
            userData={userData}
            taxData={taxData}
            datalist={item}
          />
        );
      }
    );

    SellBusinessIncomePDF(futurePlanData?.income_business_items)?.forEach(
      (item, index) => {
        pages.push(
          <IncomeFuturePDF
            page={37}
            isFirst={index === 0}
            isLast={
              SellBusinessIncomePDF(futurePlanData?.income_business_items)
                ?.length ===
              index + 1
            }
            userData={userData}
            taxData={taxData}
            datalist={item}
          />
        );
      }
    );

    PropertyIncomePDF(futurePlanData?.income_property_items)?.forEach(
      (item, index) => {
        pages.push(
          <IncomeFuturePDF
            page={37}
            isFirst={index === 0}
            isLast={
              PropertyIncomePDF(futurePlanData?.income_property_items)
                ?.length ===
              index + 1
            }
            userData={userData}
            taxData={taxData}
            datalist={item}
          />
        );
      }
    );

    OtherIncomePDF(futurePlanData?.income_other_items)?.forEach(
      (item, index) => {
        pages.push(
          <IncomeFuturePDF
            page={37}
            isFirst={index === 0}
            isLast={
              OtherIncomePDF(futurePlanData?.income_other_items)?.length ===
              index + 1
            }
            userData={userData}
            taxData={taxData}
            datalist={item}
          />
        );
      }
    );

    pages = [...pages, <ResultChartFuturePdf page={40} />];

    pdfFutureFourFunction(userData, futurePlanData)?.forEach(
      (moneyNeedLists, moneyNeedIndex) => {
        pages.push(
          <PdfPageFutureFour
            page={40}
            userData={userData}
            moneyNeedLists={moneyNeedLists}
            is_Last={
              pdfFutureFourFunction(userData, futurePlanData)?.length ===
              moneyNeedIndex + 1
            }
          />
        );
      }
    );

    pages = [...pages, <PdfPageDebtOne page={41} />];

    chunkDebtShortItems?.forEach((chunk, index) => {
      pages.push(<PdfPageDebtOneSum page={42} chunk={chunk} index={index} />);
    });

    pages = [
      ...pages,
      <PdfPageDebtTwo page={43} debtShortItems={debtShortItems} />,
      <PdfPageDebtThree page={44} />,
      <PdfPageDebtFour page={45} />,

      // ภาคผนวก
      <PdfPageAppendix page={46} />,
    ];

    // Remove unused variables and functions
    // Remove investItemsFour, interest_min, totalCreditor, merge if not used
    // Use forEach instead of map for side effects
    educationData.forEach((educationItem, index) => {
      pages.push(
        <PdfPageAppendixEducationTwo
          index={index}
          educationItem={educationItem}
          page={index}
        />
      );
    });

    pages = [
      ...pages,
      <AllInsuranceNumber page={48} balanceData={balanceData} />,
    ];

    InsureRanceLists(balanceData)?.InsuranceLifes?.forEach((item, index) => {
      pages.push(<ExpenseInsuranceDetailPDF page={48} data={item} />);
      pages.push(<ExpenseInsuranceDetailTwoPDF page={48} data={item} />);
      pages.push(<ExpenseInsuranceDetailThreePDF page={48} data={item} />);
      pages.push(<ExpenseInsuranceDetailFourPDF page={48} data={item} />);
    });

    InsureRanceLists(balanceData)?.InsuranceAccidents?.forEach(
      (item, index) => {
        pages.push(<ExpenseInsuranceDetailFifthPDF page={49} data={item} />);
      }
    );

    InsureRanceLists(balanceData)?.Insurancecars?.forEach((item, index) => {
      pages.push(<ExpenseInsuranceDetailCarPDF page={50} data={item} />);
    });

    InsureRanceLists(balanceData)?.InsuranceHomes?.forEach((item, index) => {
      pages.push(<ExpenseInsuranceDetailHomePDF page={51} data={item} />);
    });

    InsureRanceLists(balanceData)?.InsuranceFires?.forEach((item, index) => {
      pages.push(<ExpenseInsuranceDetailFirePDF page={52} data={item} />);
    });

    return pages;
  }, [
    userData,
    insuranceData,
    investData,
    balanceData,
    taxData,
    futurePlanData,
    educationData,
    debtData,
    retireData,
    chunkDebtShortItems,
    debtShortItems,
    investItems?.length,
    totalException,
    totalTaxDeduct,
  ]);

  // Remove previewPages and page navigation, render all pages
  return (
    <div className="h-screen">
      <PdfDownload />
      <div id="pdf-content" className={cn(STYLE_PDF_CONTENT)}>
        <PageLanding />
        {allPages?.map((item, index) => {
          return React.cloneElement(item, { page: index + 1 });
        })}
      </div>
      {pdfDataUri && (
        <iframe
          title="Preview PDF"
          style={{ width: "100%", height: "100%", margin: "0 auto" }}
          src={pdfDataUri}
        />
      )}
    </div>
  );
};

export default PDFPreviewer;
